{
  "WHATSAPP_TEMPLATE_MGMT": {
    "TITLE": "Predloge",
    "DESCRIPTION": "Oglejte si predloge sporočil, sinhronizirane iz vaših nabiralnikov WhatsApp. Za ustvarjanje ali urejanje predloge to storite pri svojem ponudniku.",
    "COUNT": "Število predlog: {n}",
    "LEARN_MORE": "Preberi več o predlogah WhatsApp",
    "SYNC_TEMPLATES": "Sinhroniziraj predloge",
    "SYNC_SUCCESS": "Sinhronizacija predlog se je začela za vse nabiralnike WhatsApp. Posodobitve se lahko prikažejo čez nekaj minut.",
    "PARTIAL_SYNC_ERROR": "Sinhronizacija predlog se je začela za nekatere nabiralnike WhatsApp, drugih pa ni bilo mogoče sinhronizirati.",
    "SYNC_ERROR": "Sinhronizacije predlog ni bilo mogoče začeti. Poskusite znova.",
    "SEARCH_PLACEHOLDER": "Iskanje po vsebini ali imenu ...",
    "MANAGE_IN_META": "Upravljaj v Meta",
    "LOADING": "Nalaganje predlog WhatsApp...",
    "EMPTY": "Ni najdenih predlog WhatsApp.",
    "NO_RESULTS": "Nobena predloga ne ustreza vašim filtrom.",
    "FETCH_ERROR": "Predlog WhatsApp ni bilo mogoče naložiti. Poskusite znova.",
    "PARTIAL_FETCH_ERROR": "Nekaterih predlog WhatsApp ni bilo mogoče naložiti. Poskusite znova.",
    "LAST_SYNC_ATTEMPT": "Zadnji poskus sinhronizacije: {date}",
    "MORE_INBOXES": "+{n}",
    "STATUSES": {
      "UNSUBMITTED": "Ni oddano v odobritev WhatsApp"
    },
    "FILTERS": {
      "ALL_INBOXES": "Vsi nabiralniki",
      "ALL_LANGUAGES": "Vsi jeziki",
      "ALL_TYPES": "Vse vrste"
    },
    "TYPES": {
      "TEXT": "Besedilo",
      "IMAGE": "Slika",
      "VIDEO": "Video",
      "DOCUMENT": "Dokument",
      "CALL_TO_ACTION": "Poziv k dejanju",
      "COPY_CODE": "Kopiraj kodo"
    },
    "PREVIEW": {
      "TITLE": "Predogled predloge",
      "DESCRIPTION": "Poglejte, kako je ta predloga videti v WhatsAppu.",
      "OPEN": "Predogled {name}",
      "CLOSE": "Zapri predogled",
      "DETAILS": "Podrobnosti predloge",
      "STATUS": "Status",
      "TYPE": "Vrsta vsebine",
      "CATEGORY": "Kategorija",
      "LANGUAGE": "Jezik",
      "INBOXES": "Nabiralniki"
    }
  }
}
